window.themeJs = themeJs || {};


( function($) {
    /**
     * https://stackoverflow.com/questions/487073/check-if-element-is-visible-after-scrolling
     * @constructor
     */
    function Utils() {

    }

    Utils.prototype = {
        constructor: Utils,
        isElementInView: function (element, fullyInView) {
            var pageTop = $(window).scrollTop();
            var pageBottom = pageTop + $(window).height();
            var elementTop = $(element).offset().top;
            var elementBottom = elementTop + $(element).outerHeight();

            if (fullyInView === true) {
                return ((pageTop < elementTop) && (pageBottom > elementBottom));
            } else {
                return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
            }
        }
    };

    themeJs.Utils = new Utils();

})(jQuery);

